import { NSABoxSecret, NSARouterMakerResult } from 'namirasoft-account-react';
import { NamingConvention } from 'namirasoft-core';
import { AWSRow, BasicAuthRow, TokenAuthRow } from "namirasoft-credential";
import { LogGroupRow } from "namirasoft-log";
import { RegionRow } from 'namirasoft-nws-region';
import { VolumeRow, VolumeStatus, VolumeType } from 'namirasoft-nws-volume';
import { NamirasoftMap } from 'namirasoft-site-map';
import { NSBox, NSBoxBoolean, NSBoxEntity, NSBoxEnum, NSBoxInteger, NSBoxString, NSBoxTextArea, NSBoxURL, NSColumn, NSRow } from 'namirasoft-site-react';
import { Component, createRef } from 'react';
import { NWSVolumeEntities } from '../NWSVolumeEntities';
import { NWSVolumeLayout } from '../NWSVolumeLayout';
import { NWSVolumeRouterProps } from '../NWSVolumeRouterProps';

export interface VolumeEditPageProps extends NSARouterMakerResult, NWSVolumeRouterProps
{
    isEdit: boolean;
}

export interface VolumeEditPageState
{
    type: VolumeType | null;
}

export default class VolumeEditPage extends Component<VolumeEditPageProps, VolumeEditPageState>
{
    private NSBoxString_Name = createRef<NSBoxString>();
    private NSBoxEnum_Type = createRef<NSBoxEnum<VolumeType>>();
    private NSBoxEntity_Region = createRef<NSBoxEntity<RegionRow>>();
    private NSBoxEntity_LogGroupID = createRef<NSBoxEntity<LogGroupRow>>();
    private NSBoxURL_UIUrl = createRef<NSBoxURL>();
    private NSBoxTextArea_Description = createRef<NSBoxTextArea>();

    // 1Fichier
    private NSABoxSecret_1Fichier_APIKey = createRef<NSABoxSecret>();

    // Akamai Net Storage
    private NSBoxString_AkamaiNetStorage_Host = createRef<NSBoxString>();
    private NSBoxString_AkamaiNetStorage_Account = createRef<NSBoxString>();
    private NSABoxSecret_AkamaiNetStorage_Secret = createRef<NSABoxSecret>();

    // AWSS3
    private NSBoxEntity_AWSS3_AWSCredentialID = createRef<NSBoxEntity<AWSRow>>();
    private NSBoxString_AWSS3_Provider = createRef<NSBoxString>();
    private NSBoxString_AWSS3_Region = createRef<NSBoxString>();

    // Azure Blob Storage
    // (1.Certificate)
    // private NSABoxSecret_AzureBlobStorageCertificate_ClientCertificatePassword = createRef<NSABoxSecret>();
    // private NSBoxString_AzureBlobStorageCertificate_ClientCertificatePath = createRef<NSBoxString>();
    // private NSBoxString_AzureBlobStorageCertificate_ClientID = createRef<NSBoxString>();
    // private NSBoxString_AzureBlobStorageCertificate_ClientSendCertificateChain = createRef<NSBoxString>();
    // private NSBoxString_AzureBlobStorageCertificate_Tenant = createRef<NSBoxString>();
    // (2.Key)
    private NSBoxString_AzureBlobStorageKey_Account = createRef<NSBoxString>();
    private NSABoxSecret_AzureBlobStorageKey_Key = createRef<NSABoxSecret>();
    // (3.User Pass)
    // private NSBoxString_AzureBlobStorageUserPass_Tenant = createRef<NSBoxString>();
    // private NSBoxString_AzureBlobStorageUserPass_ClientID = createRef<NSBoxString>();
    // private NSBoxString_AzureBlobStorageUserPass_BasicAuthCredentialID = createRef<NSBoxString>();

    // Azure Files 
    // (1.Certificate)
    // private NSABoxSecret_AzureFilesCertificate_ClientCertificatePassword = createRef<NSABoxSecret>();
    // private NSBoxString_AzureFilesCertificate_ClientCertificatePath = createRef<NSBoxString>();
    // private NSBoxString_AzureFilesCertificate_ClientID = createRef<NSBoxString>();
    // private NSBoxString_AzureFilesCertificate_ClientSendCertificateChain = createRef<NSBoxString>();
    // private NSBoxString_AzureFilesCertificate_Tenant = createRef<NSBoxString>();
    // private NSBoxString_AzureFilesCertificate_ShareName = createRef<NSBoxString>();
    // (2.Connection String)
    // private NSBoxString_AzureFilesConnectionString_ConnectionString = createRef<NSBoxString>();
    // private NSBoxString_AzureFilesConnectionString_ShareName = createRef<NSBoxString>();
    // (3.Key)
    private NSBoxString_AzureFilesKey_Account = createRef<NSBoxString>();
    private NSABoxSecret_AzureFilesKey_Key = createRef<NSABoxSecret>();
    private NSBoxString_AzureFilesKey_ShareName = createRef<NSBoxString>();
    // (4.SAS)
    // private NSBoxURL_AzureFilesSAS_SASURL = createRef<NSBoxURL>();
    // private NSBoxString_AzureFilesSAS_ShareName = createRef<NSBoxString>();
    // (5.User Pass)
    // private NSBoxString_AzureFilesUserPass_Tenant = createRef<NSBoxString>();
    // private NSBoxString_AzureFilesUserPass_ClientID = createRef<NSBoxString>();
    // private NSBoxEntity_AzureFilesUserPass_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();
    // private NSBoxString_AzureFilesUserPass_ShareName = createRef<NSBoxString>();

    // ‌Back Blaze B2
    private NSBoxString_BackBlazeB2_Account = createRef<NSBoxString>();
    private NSABoxSecret_BackBlazeB2_Key = createRef<NSABoxSecret>();
    private NSBoxString_BackBlazeB2_HardDelete = createRef<NSBoxString>();

    // Box
    private NSBoxEntity_Box_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // Citrixe Share File
    private NSBoxEntity_CitrixeShareFile_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // Cloudinary
    private NSBoxString_Cloudinary_CloudName = createRef<NSBoxString>();
    private NSABoxSecret_Cloudinary_ApiKey = createRef<NSABoxSecret>();
    private NSABoxSecret_Cloudinary_ApiSecret = createRef<NSABoxSecret>();

    // Dropbox
    private NSBoxEntity_Dropbox_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // File Fabric
    private NSBoxURL_FileFabric_Url = createRef<NSBoxURL>();
    private NSBoxString_FileFabric_RootFolderId = createRef<NSBoxString>();
    private NSBoxEntity_FileFabric_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // File LU
    private NSABoxSecret_FileLU_Key = createRef<NSABoxSecret>();

    // FTP
    private NSBoxString_FTP_Host = createRef<NSBoxString>();
    private NSBoxInteger_FTP_Port = createRef<NSBoxInteger>();
    private NSBoxEntity_FTP_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();
    private NSBoxString_FTP_TLS = createRef<NSBoxString>();
    private NSBoxString_FTP_ExplicitTLS = createRef<NSBoxString>();

    // GCP Cloud Storage 
    // (1.OAuth2)
    private NSBoxInteger_GCPCloudStorageOAuth2_ProjectNumber = createRef<NSBoxInteger>();
    private NSBoxEntity_GCPCloudStorageOAuth2_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();
    private NSBoxString_GCPLocation = createRef<NSBoxString>();
    // (2.Service Account File)
    // private NSBoxString_GCPCloudStorageServiceAccountFile_ServiceAccountFile = createRef<NSBoxString>();
    // private NSBoxInteger_GCPCloudStorageServiceAccountFile_ProjectNumber = createRef<NSBoxInteger>();
    // private NSBoxString_GCPCloudStorageServiceAccountFile_Location = createRef<NSBoxString>();

    // GoFile
    private NSBoxEntity_GoFile_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // Google Drive 
    // (1.OAuth)
    private NSBoxEntity_GoogleDrive_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();
    // (2.Service Account)
    // private NSBoxString_GoogleDriveServiceAccount_Scope = createRef<NSBoxString>();
    // private NSBoxString_GoogleDriveServiceAccount_ServiceAccountFile = createRef<NSBoxString>();

    // Google Photos
    private NSBoxEntity_GooglePhotos_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();
    private NSBoxBoolean_GooglePhotos_ReadOnly = createRef<NSBoxBoolean>();

    // HDFS
    private NSBoxString_HDFS_Namenode = createRef<NSBoxString>();
    private NSBoxString_HDFS_Username = createRef<NSBoxString>();

    // HTTP
    private NSBoxURL_HTTP_Url = createRef<NSBoxURL>();

    // HiDrive
    private NSBoxString_HiDrive_ScopeAccess = createRef<NSBoxString>();
    private NSBoxEntity_HiDrive_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // ICloud Drive
    private NSBoxString_ICloudDrive_AppleID = createRef<NSBoxString>();
    private NSABoxSecret_ICloudDrive_Password = createRef<NSABoxSecret>();

    // ImageKit
    private NSBoxURL_ImageKit_Endpoint = createRef<NSBoxURL>();
    private NSBoxString_ImageKit_PublicKey = createRef<NSBoxString>();
    private NSABoxSecret_ImageKit_PrivateKey = createRef<NSABoxSecret>();

    // Internet Archive
    private NSBoxString_InternetArchive_AccessKeyID = createRef<NSBoxString>();
    private NSABoxSecret_InternetArchive_SecretAccessKey = createRef<NSABoxSecret>();
    private NSBoxString_InternetArchive_ItemDerive = createRef<NSBoxString>();

    // Jottacloud
    private NSBoxURL_Jottacloud_TokenURL = createRef<NSBoxURL>();
    private NSBoxEntity_Jottacloud_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // Koofr
    private NSBoxString_Koofr_Provider = createRef<NSBoxString>();
    private NSBoxURL_Koofr_Endpoint = createRef<NSBoxURL>();
    private NSBoxEntity_Koofr_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // Linkbox
    private NSBoxEntity_Linkbox_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // Mailru
    private NSBoxEntity_Mailru_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // Mega
    private NSBoxString_Mega_2FA = createRef<NSBoxString>();
    private NSBoxEntity_Mega_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // Namirasoft Bucket Storage
    private NSBoxString_NamirasoftBucketStorage_Provider = createRef<NSBoxString>();
    private NSBoxString_NamirasoftBucketStorage_AccessKeyID = createRef<NSBoxString>();
    private NSABoxSecret_NamirasoftBucketStorage_SecretAccessKey = createRef<NSABoxSecret>();
    private NSBoxString_NamirasoftBucketStorage_Region = createRef<NSBoxString>();

    // Namirasoft Disk Fixed Price 
    private NSBoxInteger_NamirasoftDiskFixedPrice_Size = createRef<NSBoxInteger>();

    // Namirasoft Disk Usage Based Price
    private NSBoxInteger_NamirasoftDiskUsageBasedPrice_Size = createRef<NSBoxInteger>();

    // One Drive
    private NSBoxEntity_OneDrive_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();
    private NSBoxString_OneDrive_Tenant = createRef<NSBoxString>();

    // Open Drive
    private NSBoxEntity_OpenDrive_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // Oracle Object Storage
    private NSBoxString_OracleObjectStorage_Provider = createRef<NSBoxString>();
    private NSBoxString_OracleObjectStorage_Namespace = createRef<NSBoxString>();
    private NSBoxString_OracleObjectStorage_Compartment = createRef<NSBoxString>();
    private NSBoxString_OracleObjectStorage_Region = createRef<NSBoxString>();

    // PCloud 
    // (1.OAuth)
    private NSBoxEntity_PCloud_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();
    // (2.User Pass)
    // private NSBoxString_PCloudUserPass_Hostname = createRef<NSBoxString>();
    // private NSBoxEntity_PCloudUserPass_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // PikPak
    private NSBoxEntity_PikPak_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // Pixeldrain
    private NSABoxSecret_Pixeldrain_ApiKey = createRef<NSABoxSecret>();

    // PremiumizeMe
    private NSABoxSecret_PremiumizeMe_ApiKey = createRef<NSABoxSecret>();

    // ProtonDrive
    private NSBoxString_ProtonDrive_2FA = createRef<NSBoxString>();
    private NSBoxEntity_ProtonDrive_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // Putio
    private NSBoxEntity_Putio_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // Qingstor
    private NSBoxString_Qingstor_AccessKeyID = createRef<NSBoxString>();
    private NSABoxSecret_Qingstor_SecretAccessKey = createRef<NSABoxSecret>();
    private NSBoxURL_Qingstor_Endpoint = createRef<NSBoxURL>();
    private NSBoxString_Qingstor_Zone = createRef<NSBoxString>();

    // Quatrix
    private NSABoxSecret_Quatrix_ApiKey = createRef<NSABoxSecret>();
    private NSBoxString_Quatrix_Host = createRef<NSBoxString>();

    // S3
    private NSBoxString_S3_Provider = createRef<NSBoxString>();
    private NSBoxString_S3_AccessKeyID = createRef<NSBoxString>();
    private NSABoxSecret_S3_SecretAccessKey = createRef<NSABoxSecret>();
    private NSBoxString_S3_Region = createRef<NSBoxString>();

    // SFTP
    private NSBoxString_SFTP_Host = createRef<NSBoxString>();
    private NSBoxInteger_SFTP_Port = createRef<NSBoxInteger>();
    private NSBoxTextArea_SFTP_KeyPem = createRef<NSBoxTextArea>();
    private NSBoxString_SFTP_KeyFile = createRef<NSBoxString>();
    private NSABoxSecret_SFTP_KeyFilePass = createRef<NSABoxSecret>();
    private NSBoxEntity_SFTP_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // Seafile
    private NSBoxURL_Seafile_Url = createRef<NSBoxURL>();
    private NSBoxString_Seafile_2FA = createRef<NSBoxString>();
    private NSBoxEntity_Seafile_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();
    private NSBoxString_Seafile_Library = createRef<NSBoxString>();
    private NSABoxSecret_Seafile_LibraryKey = createRef<NSABoxSecret>();

    // Sia
    private NSABoxSecret_Sia_ApiPassword = createRef<NSABoxSecret>();
    private NSBoxURL_Sia_ApiUrl = createRef<NSBoxURL>();

    // SMB
    private NSBoxString_SMB_Host = createRef<NSBoxString>();
    private NSBoxString_SMB_Port = createRef<NSBoxString>();
    private NSBoxEntity_SMB_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // Storj
    private NSABoxSecret_Storj_AccessGrant = createRef<NSABoxSecret>();

    // Swift
    private NSBoxURL_Swift_Auth = createRef<NSBoxURL>();
    private NSABoxSecret_Swift_Key = createRef<NSABoxSecret>();
    private NSBoxString_Swift_User = createRef<NSBoxString>();

    // Ulozto
    private NSBoxEntity_Ulozto_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();
    private NSBoxEntity_Ulozto_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // WebDAV 
    // (1.User Pass)
    private NSBoxURL_WebDAV_Url = createRef<NSBoxURL>();
    private NSBoxString_WebDAV_Vendor = createRef<NSBoxString>();
    private NSBoxEntity_WebDAV_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();
    // (2.Bearer Token)
    // private NSBoxURL_WebDAVBearerToken_Url = createRef<NSBoxURL>();
    // private NSBoxString_WebDAVBearerToken_Vendor = createRef<NSBoxString>();
    // private NSABoxSecret_WebDAVBearerToken_BearerToken = createRef<NSABoxSecret>();

    // Yandex
    private NSBoxEntity_Yandex_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // Zoho
    private NSBoxString_Zoho_Region = createRef<NSBoxString>();
    private NSBoxEntity_Zoho_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    constructor(props: VolumeEditPageProps)
    {
        super(props);
        this.state = { type: null };
    }

    formatName(name: string)
    {
        return NamingConvention.auto.convert(name, NamingConvention.Pascal_Case_Space);
    }

    override render()
    {
        let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);

        return (
            <NWSVolumeLayout<VolumeRow, VolumeRow>
                {...this.props}
                pages={{
                    entity: NWSVolumeEntities.volume(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): VolumeRow =>
                                    {
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let type = this.NSBoxEnum_Type.current?.getValueEnumOne(VolumeType, VolumeType.AWSS3) ?? VolumeType.AWSS3;
                                        let region_id = this.NSBoxEntity_Region.current?.getValueOne() ?? "";
                                        let log_group_id = this.NSBoxEntity_LogGroupID.current?.getValueOne() ?? "";
                                        let ui_url = this.NSBoxURL_UIUrl.current?.getValue() ?? "";
                                        let description = this.NSBoxTextArea_Description.current?.getValue() ?? "";

                                        let meta: any = {};

                                        switch (type)
                                        {
                                            case VolumeType._1Fichier:
                                                meta.api_key = this.NSABoxSecret_1Fichier_APIKey.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.AkamaiNetStorage:
                                                meta.host = this.NSBoxString_AkamaiNetStorage_Host.current?.getValue() ?? "";
                                                meta.account = this.NSBoxString_AkamaiNetStorage_Account.current?.getValue() ?? "";
                                                meta.secret = this.NSABoxSecret_AkamaiNetStorage_Secret.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.AWSS3:
                                                meta.aws_credential_id = this.NSBoxEntity_AWSS3_AWSCredentialID.current?.getValueOne() ?? "";
                                                meta.provider = this.NSBoxString_AWSS3_Provider.current?.getValue() ?? "";
                                                meta.region = this.NSBoxString_AWSS3_Region.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.AzureBlobStorage:
                                                meta.account = this.NSBoxString_AzureBlobStorageKey_Account.current?.getValue() ?? "";
                                                meta.key = this.NSABoxSecret_AzureBlobStorageKey_Key.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.AzureFiles:
                                                meta.account = this.NSBoxString_AzureFilesKey_Account.current?.getValue() ?? "";
                                                meta.key = this.NSABoxSecret_AzureFilesKey_Key.current?.getValue() ?? "";
                                                meta.share_name = this.NSBoxString_AzureFilesKey_ShareName.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.BackBlazeB2:
                                                meta.account = this.NSBoxString_BackBlazeB2_Account.current?.getValue() ?? "";
                                                meta.key = this.NSABoxSecret_BackBlazeB2_Key.current?.getValue() ?? "";
                                                meta.hard_delete = this.NSBoxString_BackBlazeB2_HardDelete.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.Box:
                                                meta.token_auth_credential_id = this.NSBoxEntity_Box_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.CitrixeShareFile:
                                                meta.token_auth_credential_id = this.NSBoxEntity_CitrixeShareFile_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.Cloudinary:
                                                meta.cloud_name = this.NSBoxString_Cloudinary_CloudName.current?.getValue() ?? "";
                                                meta.api_key = this.NSABoxSecret_Cloudinary_ApiKey.current?.getValue() ?? "";
                                                meta.api_secret = this.NSABoxSecret_Cloudinary_ApiSecret.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.DropboxOAuth:
                                                meta.token_auth_credential_id = this.NSBoxEntity_Dropbox_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.FileFabric:
                                                meta.url = this.NSBoxURL_FileFabric_Url.current?.getValue() ?? "";
                                                meta.root_folder_id = this.NSBoxString_FileFabric_RootFolderId.current?.getValue() ?? "";
                                                meta.token_auth_credential_id = this.NSBoxEntity_FileFabric_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.FileLU:
                                                meta.key = this.NSABoxSecret_FileLU_Key.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.FTP:
                                                meta.host = this.NSBoxString_FTP_Host.current?.getValue() ?? "";
                                                meta.port = this.NSBoxInteger_FTP_Port.current?.getValue() ?? 0;
                                                meta.basic_auth_credential_id = this.NSBoxEntity_FTP_BasicAuthCredentialID.current?.getValueOne() ?? "";
                                                meta.tls = this.NSBoxString_FTP_TLS.current?.getValue() ?? "";
                                                meta.explicit_tls = this.NSBoxString_FTP_ExplicitTLS.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.GCPCloudStorage:
                                                meta.project_number = this.NSBoxInteger_GCPCloudStorageOAuth2_ProjectNumber.current?.getValue() ?? 0;
                                                meta.token_auth_credential_id = this.NSBoxEntity_GCPCloudStorageOAuth2_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                meta.location = this.NSBoxString_GCPLocation.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.GoFile:
                                                meta.token_auth_credential_id = this.NSBoxEntity_GoFile_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.GoogleDrive:
                                                meta.token_auth_credential_id = this.NSBoxEntity_GoogleDrive_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.GooglePhotos:
                                                meta.token_auth_credential_id = this.NSBoxEntity_GooglePhotos_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                meta.read_only = this.NSBoxBoolean_GooglePhotos_ReadOnly.current?.getValue() ?? false;
                                                break;
                                            case VolumeType.HDFS:
                                                meta.namenode = this.NSBoxString_HDFS_Namenode.current?.getValue() ?? "";
                                                meta.username = this.NSBoxString_HDFS_Username.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.HTTP:
                                                meta.url = this.NSBoxURL_HTTP_Url.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.HiDrive:
                                                meta.scope_access = this.NSBoxString_HiDrive_ScopeAccess.current?.getValue() ?? "";
                                                meta.token_auth_credential_id = this.NSBoxEntity_HiDrive_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.ICloudDrive:
                                                meta.apple_id = this.NSBoxString_ICloudDrive_AppleID.current?.getValue() ?? "";
                                                meta.password = this.NSABoxSecret_ICloudDrive_Password.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.ImageKit:
                                                meta.endpoint = this.NSBoxURL_ImageKit_Endpoint.current?.getValue() ?? "";
                                                meta.public_key = this.NSBoxString_ImageKit_PublicKey.current?.getValue() ?? "";
                                                meta.private_key = this.NSABoxSecret_ImageKit_PrivateKey.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.InternetArchive:
                                                meta.access_key_id = this.NSBoxString_InternetArchive_AccessKeyID.current?.getValue() ?? "";
                                                meta.secret_access_key = this.NSABoxSecret_InternetArchive_SecretAccessKey.current?.getValue() ?? "";
                                                meta.item_derive = this.NSBoxString_InternetArchive_ItemDerive.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.Jottacloud:
                                                meta.tokenURL = this.NSBoxURL_Jottacloud_TokenURL.current?.getValue() ?? "";
                                                meta.token_auth_credential_id = this.NSBoxEntity_Jottacloud_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.Koofr:
                                                meta.provider = this.NSBoxString_Koofr_Provider.current?.getValue() ?? "";
                                                meta.endpoint = this.NSBoxURL_Koofr_Endpoint.current?.getValue() ?? "";
                                                meta.basic_auth_credential_id = this.NSBoxEntity_Koofr_BasicAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.Linkbox:
                                                meta.token_auth_credential_id = this.NSBoxEntity_Linkbox_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.Mailru:
                                                meta.basic_auth_credential_id = this.NSBoxEntity_Mailru_BasicAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.Mega:
                                                meta._2fa = this.NSBoxString_Mega_2FA.current?.getValue() ?? "";
                                                meta.basic_auth = this.NSBoxEntity_Mega_BasicAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.NamirasoftBucketStorage:
                                                meta.provider = this.NSBoxString_NamirasoftBucketStorage_Provider.current?.getValue() ?? "";
                                                meta.access_key_id = this.NSBoxString_NamirasoftBucketStorage_AccessKeyID.current?.getValue() ?? "";
                                                meta.secret_access_key = this.NSABoxSecret_NamirasoftBucketStorage_SecretAccessKey.current?.getValue() ?? "";
                                                meta.region = this.NSBoxString_NamirasoftBucketStorage_Region.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.NamirasoftDiskFixedPrice:
                                                meta.size = this.NSBoxInteger_NamirasoftDiskFixedPrice_Size.current?.getValue() ?? 0;
                                                break;
                                            case VolumeType.NamirasoftDiskUsageBasedPrice:
                                                meta.size = this.NSBoxInteger_NamirasoftDiskUsageBasedPrice_Size.current?.getValue() ?? 0;
                                                break;
                                            case VolumeType.OneDriveOAuth:
                                                meta.token_auth_credential_id = this.NSBoxEntity_OneDrive_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                meta.tenant = this.NSBoxString_OneDrive_Tenant.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.OpenDrive:
                                                meta.basic_auth_credential_id = this.NSBoxEntity_OpenDrive_BasicAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.OracleObjectStorage:
                                                meta.provider = this.NSBoxString_OracleObjectStorage_Provider.current?.getValue() ?? "";
                                                meta.namespace = this.NSBoxString_OracleObjectStorage_Namespace.current?.getValue() ?? "";
                                                meta.compartment = this.NSBoxString_OracleObjectStorage_Compartment.current?.getValue() ?? "";
                                                meta.region = this.NSBoxString_OracleObjectStorage_Region.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.PCloud:
                                                meta.token_auth_credential_id = this.NSBoxEntity_PCloud_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.PikPak:
                                                meta.basic_auth_credential_id = this.NSBoxEntity_PikPak_BasicAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.Pixeldrain:
                                                meta.api_key = this.NSABoxSecret_Pixeldrain_ApiKey.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.PremiumizeMe:
                                                meta.api_key = this.NSABoxSecret_PremiumizeMe_ApiKey.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.ProtonDrive:
                                                meta._2fa = this.NSBoxString_ProtonDrive_2FA.current?.getValue() ?? "";
                                                meta.basic_auth = this.NSBoxEntity_ProtonDrive_BasicAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.Putio:
                                                meta.token_auth_credential_id = this.NSBoxEntity_Putio_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.Qingstor:
                                                meta.access_key_id = this.NSBoxString_Qingstor_AccessKeyID.current?.getValue() ?? "";
                                                meta.secret_access_key = this.NSABoxSecret_Qingstor_SecretAccessKey.current?.getValue() ?? "";
                                                meta.endpoint = this.NSBoxURL_Qingstor_Endpoint.current?.getValue() ?? "";
                                                meta.zone = this.NSBoxString_Qingstor_Zone.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.Quatrix:
                                                meta.api_key = this.NSABoxSecret_Quatrix_ApiKey.current?.getValue() ?? "";
                                                meta.host = this.NSBoxString_Quatrix_Host.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.S3:
                                                meta.provider = this.NSBoxString_S3_Provider.current?.getValue() ?? "";
                                                meta.access_key_id = this.NSBoxString_S3_AccessKeyID.current?.getValue() ?? "";
                                                meta.secret_access_key = this.NSABoxSecret_S3_SecretAccessKey.current?.getValue() ?? "";
                                                meta.region = this.NSBoxString_S3_Region.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.SFTP:
                                                meta.host = this.NSBoxString_SFTP_Host.current?.getValue() ?? "";
                                                meta.port = this.NSBoxInteger_SFTP_Port.current?.getValue() ?? 0;
                                                meta.key_pem = this.NSBoxTextArea_SFTP_KeyPem.current?.getValue() ?? "";
                                                meta.key_file = this.NSBoxString_SFTP_KeyFile.current?.getValue() ?? "";
                                                meta.key_file_pass = this.NSABoxSecret_SFTP_KeyFilePass.current?.getValue() ?? "";
                                                meta.basic_auth_credential_id = this.NSBoxEntity_SFTP_BasicAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.Seafile:
                                                meta.url = this.NSBoxURL_Seafile_Url.current?.getValue() ?? "";
                                                meta._2fa = this.NSBoxString_Seafile_2FA.current?.getValue() ?? "";
                                                meta.basic_auth = this.NSBoxEntity_Seafile_BasicAuthCredentialID.current?.getValueOne() ?? "";
                                                meta.library = this.NSBoxString_Seafile_Library.current?.getValue() ?? "";
                                                meta.library_key = this.NSABoxSecret_Seafile_LibraryKey.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.Sia:
                                                meta.api_url = this.NSBoxURL_Sia_ApiUrl.current?.getValue() ?? "";
                                                meta.api_password = this.NSABoxSecret_Sia_ApiPassword.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.SMB:
                                                meta.host = this.NSBoxString_SMB_Host.current?.getValue() ?? "";
                                                meta.port = this.NSBoxString_SMB_Port.current?.getValue() ?? "";
                                                meta.basic_auth_credential_id = this.NSBoxEntity_SMB_BasicAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.Storj:
                                                meta.access_grant = this.NSABoxSecret_Storj_AccessGrant.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.Swift:
                                                meta.auth = this.NSBoxURL_Swift_Auth.current?.getValue() ?? "";
                                                meta.key = this.NSABoxSecret_Swift_Key.current?.getValue() ?? "";
                                                meta.user = this.NSBoxString_Swift_User.current?.getValue() ?? "";
                                                break;
                                            case VolumeType.Ulozto:
                                                meta.basic_auth = this.NSBoxEntity_Ulozto_BasicAuthCredentialID.current?.getValueOne() ?? "";
                                                meta.token_auth_credential_id = this.NSBoxEntity_Ulozto_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.WebDAV:
                                                meta.url = this.NSBoxURL_WebDAV_Url.current?.getValue() ?? "";
                                                meta.vendor = this.NSBoxString_WebDAV_Vendor.current?.getValue() ?? "";
                                                meta.basic_auth_credential_id = this.NSBoxEntity_WebDAV_BasicAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.Yandex:
                                                meta.token_auth_credential_id = this.NSBoxEntity_Yandex_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                            case VolumeType.Zoho:
                                                meta.region = this.NSBoxString_Zoho_Region.current?.getValue() ?? "";
                                                meta.token_auth_credential_id = this.NSBoxEntity_Zoho_TokenAuthCredentialID.current?.getValueOne() ?? "";
                                                break;
                                        }

                                        return {
                                            id: "",
                                            user_id: "",
                                            workspace_id: "",

                                            name,
                                            type,
                                            region_id,
                                            log_group_id,
                                            ui_url,
                                            meta,
                                            description,

                                            status: VolumeStatus.InProgress,
                                            status_message: "",
                                            created_at: new Date(),
                                            updated_at: new Date()
                                        };
                                    },
                                    setRow: (row: VolumeRow) =>
                                    {
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSBoxEnum_Type.current?.setValueOne(row.type);
                                        this.NSBoxEntity_Region.current?.setValueOne(row.region_id);
                                        this.NSBoxEntity_LogGroupID.current?.setValueOne(row.log_group_id);
                                        this.NSBoxURL_UIUrl.current?.setValue(row.ui_url);
                                        this.NSBoxTextArea_Description.current?.setValue(row.description);

                                        this.setState((prev) => ({ ...prev, type: row.type }), () =>
                                        {
                                            switch (row.type)
                                            {
                                                case VolumeType._1Fichier:
                                                    this.NSABoxSecret_1Fichier_APIKey.current?.setValue(row.meta.api_key);
                                                    break;
                                                case VolumeType.AkamaiNetStorage:
                                                    this.NSBoxString_AkamaiNetStorage_Host.current?.setValue(row.meta.host);
                                                    this.NSBoxString_AkamaiNetStorage_Account.current?.setValue(row.meta.account);
                                                    this.NSABoxSecret_AkamaiNetStorage_Secret.current?.setValue(row.meta.secret);
                                                    break;
                                                case VolumeType.AWSS3:
                                                    this.NSBoxEntity_AWSS3_AWSCredentialID.current?.setValueOne(row.meta.aws_credential_id);
                                                    this.NSBoxString_AWSS3_Provider.current?.setValue(row.meta.provider);
                                                    this.NSBoxString_AWSS3_Region.current?.setValue(row.meta.region);
                                                    break;
                                                case VolumeType.AzureBlobStorage:
                                                    this.NSBoxString_AzureBlobStorageKey_Account.current?.setValue(row.meta.account);
                                                    this.NSABoxSecret_AzureBlobStorageKey_Key.current?.setValue(row.meta.key);
                                                    break;
                                                case VolumeType.AzureFiles:
                                                    this.NSBoxString_AzureFilesKey_Account.current?.setValue(row.meta.account);
                                                    this.NSABoxSecret_AzureFilesKey_Key.current?.setValue(row.meta.key);
                                                    this.NSBoxString_AzureFilesKey_ShareName.current?.setValue(row.meta.share_name);
                                                    break;
                                                case VolumeType.BackBlazeB2:
                                                    this.NSBoxString_BackBlazeB2_Account.current?.setValue(row.meta.account);
                                                    this.NSABoxSecret_BackBlazeB2_Key.current?.setValue(row.meta.key);
                                                    this.NSBoxString_BackBlazeB2_HardDelete.current?.setValue(row.meta.hard_delete);
                                                    break;
                                                case VolumeType.Box:
                                                    this.NSBoxEntity_Box_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    break;
                                                case VolumeType.CitrixeShareFile:
                                                    this.NSBoxEntity_CitrixeShareFile_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    break;
                                                case VolumeType.Cloudinary:
                                                    this.NSBoxString_Cloudinary_CloudName.current?.setValue(row.meta.cloud_name);
                                                    this.NSABoxSecret_Cloudinary_ApiKey.current?.setValue(row.meta.api_key);
                                                    this.NSABoxSecret_Cloudinary_ApiSecret.current?.setValue(row.meta.api_secret);
                                                    break;
                                                case VolumeType.DropboxOAuth:
                                                    this.NSBoxEntity_Dropbox_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    break;
                                                case VolumeType.FileFabric:
                                                    this.NSBoxURL_FileFabric_Url.current?.setValue(row.meta.url);
                                                    this.NSBoxString_FileFabric_RootFolderId.current?.setValue(row.meta.root_folder_id);
                                                    this.NSBoxEntity_FileFabric_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    break;
                                                case VolumeType.FileLU:
                                                    this.NSABoxSecret_FileLU_Key.current?.setValue(row.meta.key);
                                                    break;
                                                case VolumeType.FTP:
                                                    this.NSBoxString_FTP_Host.current?.setValue(row.meta.host);
                                                    this.NSBoxInteger_FTP_Port.current?.setValue(row.meta.port);
                                                    this.NSBoxEntity_FTP_BasicAuthCredentialID.current?.setValueOne(row.meta.basic_auth_credential_id);
                                                    this.NSBoxString_FTP_TLS.current?.setValue(row.meta.tls);
                                                    this.NSBoxString_FTP_ExplicitTLS.current?.setValue(row.meta.explicit_tls);
                                                    break;
                                                case VolumeType.GCPCloudStorage:
                                                    this.NSBoxInteger_GCPCloudStorageOAuth2_ProjectNumber.current?.setValue(row.meta.project_number);
                                                    this.NSBoxEntity_GCPCloudStorageOAuth2_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    this.NSBoxString_GCPLocation.current?.setValue(row.meta.location);
                                                    break;
                                                case VolumeType.GoFile:
                                                    this.NSBoxEntity_GoFile_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    break;
                                                case VolumeType.GoogleDrive:
                                                    this.NSBoxEntity_GoogleDrive_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    break;
                                                case VolumeType.GooglePhotos:
                                                    this.NSBoxEntity_GooglePhotos_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    this.NSBoxBoolean_GooglePhotos_ReadOnly.current?.setValue(row.meta.read_only);
                                                    break;
                                                case VolumeType.HDFS:
                                                    this.NSBoxString_HDFS_Namenode.current?.setValue(row.meta.namenode);
                                                    this.NSBoxString_HDFS_Username.current?.setValue(row.meta.username);
                                                    break;
                                                case VolumeType.HTTP:
                                                    this.NSBoxURL_HTTP_Url.current?.setValue(row.meta.url);
                                                    break;
                                                case VolumeType.HiDrive:
                                                    this.NSBoxString_HiDrive_ScopeAccess.current?.setValue(row.meta.scope_access);
                                                    this.NSBoxEntity_HiDrive_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    break;
                                                case VolumeType.ICloudDrive:
                                                    this.NSBoxString_ICloudDrive_AppleID.current?.setValue(row.meta.apple_id);
                                                    this.NSABoxSecret_ICloudDrive_Password.current?.setValue(row.meta.password);
                                                    break;
                                                case VolumeType.ImageKit:
                                                    this.NSBoxURL_ImageKit_Endpoint.current?.setValue(row.meta.endpoint);
                                                    this.NSBoxString_ImageKit_PublicKey.current?.setValue(row.meta.public_key);
                                                    this.NSABoxSecret_ImageKit_PrivateKey.current?.setValue(row.meta.private_key);
                                                    break;
                                                case VolumeType.InternetArchive:
                                                    this.NSBoxString_InternetArchive_AccessKeyID.current?.setValue(row.meta.access_key_id);
                                                    this.NSABoxSecret_InternetArchive_SecretAccessKey.current?.setValue(row.meta.secret_access_key);
                                                    this.NSBoxString_InternetArchive_ItemDerive.current?.setValue(row.meta.item_derive);
                                                    break;
                                                case VolumeType.Jottacloud:
                                                    this.NSBoxURL_Jottacloud_TokenURL.current?.setValue(row.meta.tokenURL);
                                                    this.NSBoxEntity_Jottacloud_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    break;
                                                case VolumeType.Koofr:
                                                    this.NSBoxString_Koofr_Provider.current?.setValue(row.meta.provider);
                                                    this.NSBoxURL_Koofr_Endpoint.current?.setValue(row.meta.endpoint);
                                                    this.NSBoxEntity_Koofr_BasicAuthCredentialID.current?.setValueOne(row.meta.basic_auth_credential_id);
                                                    break;
                                                case VolumeType.Linkbox:
                                                    this.NSBoxEntity_Linkbox_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    break;
                                                case VolumeType.Mailru:
                                                    this.NSBoxEntity_Mailru_BasicAuthCredentialID.current?.setValueOne(row.meta.basic_auth_credential_id);
                                                    break;
                                                case VolumeType.Mega:
                                                    this.NSBoxString_Mega_2FA.current?.setValue(row.meta._2fa);
                                                    this.NSBoxEntity_Mega_BasicAuthCredentialID.current?.setValueOne(row.meta.basic_auth);
                                                    break;
                                                case VolumeType.NamirasoftBucketStorage:
                                                    this.NSBoxString_NamirasoftBucketStorage_Provider.current?.setValue(row.meta.provider);
                                                    this.NSBoxString_NamirasoftBucketStorage_AccessKeyID.current?.setValue(row.meta.access_key_id);
                                                    this.NSABoxSecret_NamirasoftBucketStorage_SecretAccessKey.current?.setValue(row.meta.secret_access_key);
                                                    this.NSBoxString_NamirasoftBucketStorage_Region.current?.setValue(row.meta.region);
                                                    break;
                                                case VolumeType.NamirasoftDiskFixedPrice:
                                                    this.NSBoxInteger_NamirasoftDiskFixedPrice_Size.current?.setValue(row.meta.size);
                                                    break;
                                                case VolumeType.NamirasoftDiskUsageBasedPrice:
                                                    this.NSBoxInteger_NamirasoftDiskUsageBasedPrice_Size.current?.setValue(row.meta.size);
                                                    break;
                                                case VolumeType.OneDriveOAuth:
                                                    this.NSBoxEntity_OneDrive_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    this.NSBoxString_OneDrive_Tenant.current?.setValue(row.meta.tenant);
                                                    break;
                                                case VolumeType.OpenDrive:
                                                    this.NSBoxEntity_OpenDrive_BasicAuthCredentialID.current?.setValueOne(row.meta.basic_auth_credential_id);
                                                    break;
                                                case VolumeType.OracleObjectStorage:
                                                    this.NSBoxString_OracleObjectStorage_Provider.current?.setValue(row.meta.provider);
                                                    this.NSBoxString_OracleObjectStorage_Namespace.current?.setValue(row.meta.namespace);
                                                    this.NSBoxString_OracleObjectStorage_Compartment.current?.setValue(row.meta.compartment);
                                                    this.NSBoxString_OracleObjectStorage_Region.current?.setValue(row.meta.region);
                                                    break;
                                                case VolumeType.PCloud:
                                                    this.NSBoxEntity_PCloud_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    break;
                                                case VolumeType.PikPak:
                                                    this.NSBoxEntity_PikPak_BasicAuthCredentialID.current?.setValueOne(row.meta.basic_auth_credential_id);
                                                    break;
                                                case VolumeType.Pixeldrain:
                                                    this.NSABoxSecret_Pixeldrain_ApiKey.current?.setValue(row.meta.api_key);
                                                    break;
                                                case VolumeType.PremiumizeMe:
                                                    this.NSABoxSecret_PremiumizeMe_ApiKey.current?.setValue(row.meta.api_key);
                                                    break;
                                                case VolumeType.ProtonDrive:
                                                    this.NSBoxString_ProtonDrive_2FA.current?.setValue(row.meta._2fa);
                                                    this.NSBoxEntity_ProtonDrive_BasicAuthCredentialID.current?.setValueOne(row.meta.basic_auth);
                                                    break;
                                                case VolumeType.Putio:
                                                    this.NSBoxEntity_Putio_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    break;
                                                case VolumeType.Qingstor:
                                                    this.NSBoxString_Qingstor_AccessKeyID.current?.setValue(row.meta.access_key_id);
                                                    this.NSABoxSecret_Qingstor_SecretAccessKey.current?.setValue(row.meta.secret_access_key);
                                                    this.NSBoxURL_Qingstor_Endpoint.current?.setValue(row.meta.endpoint);
                                                    this.NSBoxString_Qingstor_Zone.current?.setValue(row.meta.zone);
                                                    break;
                                                case VolumeType.Quatrix:
                                                    this.NSABoxSecret_Quatrix_ApiKey.current?.setValue(row.meta.api_key);
                                                    this.NSBoxString_Quatrix_Host.current?.setValue(row.meta.host);
                                                    break;
                                                case VolumeType.S3:
                                                    this.NSBoxString_S3_Provider.current?.setValue(row.meta.provider);
                                                    this.NSBoxString_S3_AccessKeyID.current?.setValue(row.meta.access_key_id);
                                                    this.NSABoxSecret_S3_SecretAccessKey.current?.setValue(row.meta.secret_access_key);
                                                    this.NSBoxString_S3_Region.current?.setValue(row.meta.region);
                                                    break;
                                                case VolumeType.SFTP:
                                                    this.NSBoxString_SFTP_Host.current?.setValue(row.meta.host);
                                                    this.NSBoxInteger_SFTP_Port.current?.setValue(row.meta.port);
                                                    this.NSBoxTextArea_SFTP_KeyPem.current?.setValue(row.meta.key_pem);
                                                    this.NSBoxString_SFTP_KeyFile.current?.setValue(row.meta.key_file);
                                                    this.NSABoxSecret_SFTP_KeyFilePass.current?.setValue(row.meta.key_file_pass);
                                                    this.NSBoxEntity_SFTP_BasicAuthCredentialID.current?.setValueOne(row.meta.basic_auth_credential_id);
                                                    break;
                                                case VolumeType.Seafile:
                                                    this.NSBoxURL_Seafile_Url.current?.setValue(row.meta.url);
                                                    this.NSBoxString_Seafile_2FA.current?.setValue(row.meta._2fa);
                                                    this.NSBoxEntity_Seafile_BasicAuthCredentialID.current?.setValueOne(row.meta.basic_auth);
                                                    this.NSBoxString_Seafile_Library.current?.setValue(row.meta.library);
                                                    this.NSABoxSecret_Seafile_LibraryKey.current?.setValue(row.meta.library_key);
                                                    break;
                                                case VolumeType.Sia:
                                                    this.NSBoxURL_Sia_ApiUrl.current?.setValue(row.meta.api_url);
                                                    this.NSABoxSecret_Sia_ApiPassword.current?.setValue(row.meta.api_password);
                                                    break;
                                                case VolumeType.SMB:
                                                    this.NSBoxString_SMB_Host.current?.setValue(row.meta.host);
                                                    this.NSBoxString_SMB_Port.current?.setValue(row.meta.port);
                                                    this.NSBoxEntity_SMB_BasicAuthCredentialID.current?.setValueOne(row.meta.basic_auth_credential_id);
                                                    break;
                                                case VolumeType.Storj:
                                                    this.NSABoxSecret_Storj_AccessGrant.current?.setValue(row.meta.access_grant);
                                                    break;
                                                case VolumeType.Swift:
                                                    this.NSBoxURL_Swift_Auth.current?.setValue(row.meta.auth);
                                                    this.NSABoxSecret_Swift_Key.current?.setValue(row.meta.key);
                                                    this.NSBoxString_Swift_User.current?.setValue(row.meta.user);
                                                    break;
                                                case VolumeType.Ulozto:
                                                    this.NSBoxEntity_Ulozto_BasicAuthCredentialID.current?.setValueOne(row.meta.basic_auth);
                                                    this.NSBoxEntity_Ulozto_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    break;
                                                case VolumeType.WebDAV:
                                                    this.NSBoxURL_WebDAV_Url.current?.setValue(row.meta.url);
                                                    this.NSBoxString_WebDAV_Vendor.current?.setValue(row.meta.vendor);
                                                    this.NSBoxEntity_WebDAV_BasicAuthCredentialID.current?.setValueOne(row.meta.basic_auth_credential_id);
                                                    break;
                                                case VolumeType.Yandex:
                                                    this.NSBoxEntity_Yandex_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    break;
                                                case VolumeType.Zoho:
                                                    this.NSBoxString_Zoho_Region.current?.setValue(row.meta.region);
                                                    this.NSBoxEntity_Zoho_TokenAuthCredentialID.current?.setValueOne(row.meta.token_auth_credential_id);
                                                    break;
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn style={{ maxWidth: "35rem" }}>
                    <NSRow style={{ justifyContent: "flex-start" }}>
                        <NSBoxString
                            ref={this.NSBoxString_Name}
                            title="Name"
                            required
                        />
                        <NSBoxEnum<VolumeType>
                            ref={this.NSBoxEnum_Type}
                            title="Type"
                            required
                            multiple={false}
                            getEnumObject={() => VolumeType}
                            getTitle={(item) => this.formatName(item)}
                            onChanged={() =>
                            {
                                let type = this.NSBoxEnum_Type.current?.getValueEnumOne(VolumeType, VolumeType.NamirasoftBucketStorage) ?? null;
                                this.setState({ type });
                            }}
                        />
                        <NSBoxEntity<RegionRow>
                            ref={this.NSBoxEntity_Region}
                            title="Region"
                            required
                            multiple={false}
                            table={namirasoft.nws_region.tables.region}
                            getTitle={(item) => item.country}
                            getValue={(item) => item.id}
                            getSort={() => null}
                        />
                        <NSBoxEntity<LogGroupRow>
                            ref={this.NSBoxEntity_LogGroupID}
                            title="Log Group"
                            required={false}
                            multiple={false}
                            table={namirasoft.log.tables.log_group}
                            getTitle={(item) => item.name}
                            getValue={(item) => item.id}
                            getSort={() => null}
                        />
                        <NSBoxURL
                            ref={this.NSBoxURL_UIUrl}
                            title="UI URL"
                            required={false}
                            style={{ width: NSBox.width.double }}
                        />
                        {
                            this.state.type === VolumeType._1Fichier &&
                            <NSABoxSecret
                                {...this.props}
                                ref={this.NSABoxSecret_1Fichier_APIKey}
                                title="API Key"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.AkamaiNetStorage &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_AkamaiNetStorage_Account}
                                    title="Account"
                                    required
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_AkamaiNetStorage_Host}
                                    title="Host"
                                    required
                                />
                                <NSABoxSecret
                                    ref={this.NSABoxSecret_AkamaiNetStorage_Secret}
                                    {...this.props}
                                    title="Secret"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.AWSS3 &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_AWSS3_Provider}
                                    title="Provider"
                                    required
                                    auto_complete='one-time-code'
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_AWSS3_Region}
                                    title="Region"
                                    required
                                    auto_complete='one-time-code'
                                />
                                <NSBoxEntity<AWSRow>
                                    ref={this.NSBoxEntity_AWSS3_AWSCredentialID}
                                    title="AWS Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.aws}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.AzureBlobStorage &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_AzureBlobStorageKey_Account}
                                    title="Account"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSABoxSecret
                                    ref={this.NSABoxSecret_AzureBlobStorageKey_Key}
                                    {...this.props}
                                    title="Key"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.AzureFiles &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_AzureFilesKey_Account}
                                    title="Account"
                                    required
                                    auto_complete='one-time-code'
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_AzureFilesKey_ShareName}
                                    title="Share Name"
                                    required
                                />
                                <NSABoxSecret
                                    ref={this.NSABoxSecret_AzureFilesKey_Key}
                                    {...this.props}
                                    title="Key"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.BackBlazeB2 &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_BackBlazeB2_Account}
                                    title="Account"
                                    required
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_BackBlazeB2_HardDelete}
                                    title="Hard Delete"
                                    required
                                />
                                <NSABoxSecret
                                    {...this.props}
                                    ref={this.NSABoxSecret_BackBlazeB2_Key}
                                    title="Key"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.Box &&
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_Box_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.CitrixeShareFile &&
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_CitrixeShareFile_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.Cloudinary &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_Cloudinary_CloudName}
                                    title="Cloud Name"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSABoxSecret
                                    ref={this.NSABoxSecret_Cloudinary_ApiKey}
                                    {...this.props}
                                    title="API Key"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSABoxSecret
                                    ref={this.NSABoxSecret_Cloudinary_ApiSecret}
                                    {...this.props}
                                    title="API Secret"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.DropboxOAuth &&
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_Dropbox_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.FileFabric &&
                            <>
                                <NSBoxURL
                                    ref={this.NSBoxURL_FileFabric_Url}
                                    title="URL"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_FileFabric_RootFolderId}
                                    title="Root Folder ID"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxEntity<TokenAuthRow>
                                    ref={this.NSBoxEntity_FileFabric_TokenAuthCredentialID}
                                    title="Token Auth Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.token_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.FileLU &&
                            <NSABoxSecret
                                ref={this.NSABoxSecret_FileLU_Key}
                                {...this.props}
                                title="Key"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.FTP &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_FTP_Host}
                                    title="Host"
                                    required
                                />
                                <NSBoxInteger
                                    ref={this.NSBoxInteger_FTP_Port}
                                    title="Port"
                                    required
                                />
                                <NSBoxEntity<BasicAuthRow>
                                    ref={this.NSBoxEntity_FTP_BasicAuthCredentialID}
                                    title="Basic Auth Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.basic_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_FTP_TLS}
                                    title="TLS"
                                    required
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_FTP_ExplicitTLS}
                                    title="Explicit TLS"
                                    required
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.GCPCloudStorage &&
                            <>
                                <NSBoxInteger
                                    ref={this.NSBoxInteger_GCPCloudStorageOAuth2_ProjectNumber}
                                    title="Project Number"
                                    required
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_GCPLocation}
                                    title="Location"
                                    required
                                />
                                <NSBoxEntity<TokenAuthRow>
                                    ref={this.NSBoxEntity_GCPCloudStorageOAuth2_TokenAuthCredentialID}
                                    title="Token Auth Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.token_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.GoFile &&
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_GoFile_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.GoogleDrive &&
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_GoogleDrive_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.GooglePhotos &&
                            <>
                                <NSBoxEntity<TokenAuthRow>
                                    ref={this.NSBoxEntity_GooglePhotos_TokenAuthCredentialID}
                                    title="Token Auth Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.token_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxBoolean
                                    ref={this.NSBoxBoolean_GooglePhotos_ReadOnly}
                                    title="Read Only"
                                    required
                                    hideHeader
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.HDFS &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_HDFS_Namenode}
                                    title="Namenode"
                                    required
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_HDFS_Username}
                                    title="Username"
                                    required
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.HTTP &&
                            <NSBoxURL
                                ref={this.NSBoxURL_HTTP_Url}
                                title="URL"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.HiDrive &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_HiDrive_ScopeAccess}
                                    title="Scope Access"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxEntity<TokenAuthRow>
                                    ref={this.NSBoxEntity_HiDrive_TokenAuthCredentialID}
                                    title="Token Auth Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.token_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.ICloudDrive &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_ICloudDrive_AppleID}
                                    title="Apple ID"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSABoxSecret
                                    ref={this.NSABoxSecret_ICloudDrive_Password}
                                    {...this.props}
                                    title="Password"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.ImageKit &&
                            <>
                                <NSBoxURL
                                    ref={this.NSBoxURL_ImageKit_Endpoint}
                                    title="Endpoint"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_ImageKit_PublicKey}
                                    title="Public Key"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSABoxSecret
                                    ref={this.NSABoxSecret_ImageKit_PrivateKey}
                                    {...this.props}
                                    title="Private Key"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.InternetArchive &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_InternetArchive_AccessKeyID}
                                    title="Access Key ID"
                                    required
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_InternetArchive_ItemDerive}
                                    title="Item Derive"
                                    required
                                />
                                <NSABoxSecret
                                    ref={this.NSABoxSecret_InternetArchive_SecretAccessKey}
                                    {...this.props}
                                    title="Secret Access Key"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.Jottacloud &&
                            <>
                                <NSBoxURL
                                    ref={this.NSBoxURL_Jottacloud_TokenURL}
                                    title="Token URL"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxEntity<TokenAuthRow>
                                    ref={this.NSBoxEntity_Jottacloud_TokenAuthCredentialID}
                                    title="Token Auth Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.token_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.Koofr &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_Koofr_Provider}
                                    title="Provider"
                                    required
                                />
                                <NSBoxURL
                                    ref={this.NSBoxURL_Koofr_Endpoint}
                                    title="Endpoint"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxEntity<BasicAuthRow>
                                    ref={this.NSBoxEntity_Koofr_BasicAuthCredentialID}
                                    title="Basic Auth Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.basic_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.Linkbox &&
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_Linkbox_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.Mailru &&
                            <NSBoxEntity<BasicAuthRow>
                                ref={this.NSBoxEntity_Mailru_BasicAuthCredentialID}
                                title="Basic Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.basic_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.Mega &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_Mega_2FA}
                                    title="2FA"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxEntity<BasicAuthRow>
                                    ref={this.NSBoxEntity_Mega_BasicAuthCredentialID}
                                    title="Basic Auth Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.basic_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.NamirasoftBucketStorage &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_NamirasoftBucketStorage_Provider}
                                    title="Provider"
                                    required
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_NamirasoftBucketStorage_Region}
                                    title="Region"
                                    required
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_NamirasoftBucketStorage_AccessKeyID}
                                    title="Access Key ID"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSABoxSecret
                                    ref={this.NSABoxSecret_NamirasoftBucketStorage_SecretAccessKey}
                                    {...this.props}
                                    title="Secret Access Key"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.NamirasoftDiskFixedPrice &&
                            <NSBoxInteger
                                ref={this.NSBoxInteger_NamirasoftDiskFixedPrice_Size}
                                title='Size'
                                required
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.NamirasoftDiskUsageBasedPrice &&
                            <NSBoxInteger
                                ref={this.NSBoxInteger_NamirasoftDiskUsageBasedPrice_Size}
                                title='Size'
                                required
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.OneDriveOAuth &&
                            <>
                                <NSBoxEntity<TokenAuthRow>
                                    ref={this.NSBoxEntity_OneDrive_TokenAuthCredentialID}
                                    title="Token Auth Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.token_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_OneDrive_Tenant}
                                    title="Tenant"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.OpenDrive &&
                            <NSBoxEntity<BasicAuthRow>
                                ref={this.NSBoxEntity_OpenDrive_BasicAuthCredentialID}
                                title="Basic Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.basic_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.OracleObjectStorage &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_OracleObjectStorage_Provider}
                                    title="Provider"
                                    required
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_OracleObjectStorage_Namespace}
                                    title="Namespace"
                                    required
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_OracleObjectStorage_Compartment}
                                    title="Compartment"
                                    required
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_OracleObjectStorage_Region}
                                    title="Region"
                                    required
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.PCloud &&
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_PCloud_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.PikPak &&
                            <NSBoxEntity<BasicAuthRow>
                                ref={this.NSBoxEntity_PikPak_BasicAuthCredentialID}
                                title="Basic Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.basic_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.Pixeldrain &&
                            <NSABoxSecret
                                ref={this.NSABoxSecret_Pixeldrain_ApiKey}
                                {...this.props}
                                title="API Key"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.PremiumizeMe &&
                            <NSABoxSecret
                                ref={this.NSABoxSecret_PremiumizeMe_ApiKey}
                                {...this.props}
                                title="API Key"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.ProtonDrive &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_ProtonDrive_2FA}
                                    title="2FA"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxEntity<BasicAuthRow>
                                    ref={this.NSBoxEntity_ProtonDrive_BasicAuthCredentialID}
                                    title="Basic Auth Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.basic_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.Putio &&
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_Putio_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.Qingstor &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_Qingstor_AccessKeyID}
                                    title="Access Key ID"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSABoxSecret
                                    ref={this.NSABoxSecret_Qingstor_SecretAccessKey}
                                    {...this.props}
                                    title="Secret Access Key"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxURL
                                    ref={this.NSBoxURL_Qingstor_Endpoint}
                                    title="Endpoint"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_Qingstor_Zone}
                                    title="Zone"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.Quatrix &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_Quatrix_Host}
                                    title="Host"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSABoxSecret
                                    ref={this.NSABoxSecret_Quatrix_ApiKey}
                                    {...this.props}
                                    title="API Key"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.S3 &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_S3_Provider}
                                    title="Provider"
                                    required
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_S3_Region}
                                    title="Region"
                                    required
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_S3_AccessKeyID}
                                    title="Access Key ID"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSABoxSecret
                                    ref={this.NSABoxSecret_S3_SecretAccessKey}
                                    {...this.props}
                                    title="Secret Access Key"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.SFTP &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_SFTP_Host}
                                    title="Host"
                                    required
                                />
                                <NSBoxInteger
                                    ref={this.NSBoxInteger_SFTP_Port}
                                    title="Port"
                                    required
                                />
                                <NSBoxTextArea
                                    ref={this.NSBoxTextArea_SFTP_KeyPem}
                                    title="Key PEM"
                                    required={false}
                                    style={{ width: "100%" }}
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_SFTP_KeyFile}
                                    title="Key File"
                                    required={false}
                                />
                                <NSABoxSecret
                                    ref={this.NSABoxSecret_SFTP_KeyFilePass}
                                    {...this.props}
                                    title="Key File Password"
                                    required={false}
                                    auto_complete='one-time-code'
                                />
                                <NSBoxEntity<BasicAuthRow>
                                    ref={this.NSBoxEntity_SFTP_BasicAuthCredentialID}
                                    title="Basic Auth Credential"
                                    required={false}
                                    multiple={false}
                                    table={namirasoft.credential.tables.basic_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.Seafile &&
                            <>
                                <NSBoxURL
                                    ref={this.NSBoxURL_Seafile_Url}
                                    title="URL"
                                    required
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_Seafile_2FA}
                                    title="2FA"
                                    required
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_Seafile_Library}
                                    title="Library"
                                    required
                                />
                                <NSABoxSecret
                                    ref={this.NSABoxSecret_Seafile_LibraryKey}
                                    {...this.props}
                                    title="Library Key"
                                    required
                                    auto_complete='one-time-code'
                                />
                                <NSBoxEntity<BasicAuthRow>
                                    ref={this.NSBoxEntity_Seafile_BasicAuthCredentialID}
                                    title="Basic Auth Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.basic_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.Sia &&
                            <>
                                <NSBoxURL
                                    ref={this.NSBoxURL_Sia_ApiUrl}
                                    title="API URL"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSABoxSecret
                                    ref={this.NSABoxSecret_Sia_ApiPassword}
                                    {...this.props}
                                    title="API Password"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.SMB &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_SMB_Host}
                                    title="Host"
                                    required
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_SMB_Port}
                                    title="Port"
                                    required
                                />
                                <NSBoxEntity<BasicAuthRow>
                                    ref={this.NSBoxEntity_SMB_BasicAuthCredentialID}
                                    title="Basic Auth Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.basic_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.Storj &&
                            <NSABoxSecret
                                ref={this.NSABoxSecret_Storj_AccessGrant}
                                {...this.props}
                                title="Access Grant"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.Swift &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_Swift_User}
                                    title="User"
                                    required
                                />
                                <NSBoxURL
                                    ref={this.NSBoxURL_Swift_Auth}
                                    title="Auth"
                                    required
                                />
                                <NSABoxSecret
                                    ref={this.NSABoxSecret_Swift_Key}
                                    {...this.props}
                                    title="Key"
                                    required
                                    auto_complete='one-time-code'
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.Ulozto &&
                            <>
                                <NSBoxEntity<BasicAuthRow>
                                    ref={this.NSBoxEntity_Ulozto_BasicAuthCredentialID}
                                    title="Basic Auth Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.basic_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxEntity<TokenAuthRow>
                                    ref={this.NSBoxEntity_Ulozto_TokenAuthCredentialID}
                                    title="Token Auth Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.token_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.WebDAV &&
                            <>
                                <NSBoxURL
                                    ref={this.NSBoxURL_WebDAV_Url}
                                    title="URL"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxString
                                    ref={this.NSBoxString_WebDAV_Vendor}
                                    title="Vendor"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxEntity<BasicAuthRow>
                                    ref={this.NSBoxEntity_WebDAV_BasicAuthCredentialID}
                                    title="Basic Auth Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.basic_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        {
                            this.state.type === VolumeType.Yandex &&
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_Yandex_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        }
                        {
                            this.state.type === VolumeType.Zoho &&
                            <>
                                <NSBoxString
                                    ref={this.NSBoxString_Zoho_Region}
                                    title="Region"
                                    required
                                    style={{ width: NSBox.width.double }}
                                />
                                <NSBoxEntity<TokenAuthRow>
                                    ref={this.NSBoxEntity_Zoho_TokenAuthCredentialID}
                                    title="Token Auth Credential"
                                    required
                                    multiple={false}
                                    table={namirasoft.credential.tables.token_auth}
                                    getTitle={(item) => item.name}
                                    getValue={(item) => item.id}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                            </>
                        }
                        <NSBoxTextArea
                            ref={this.NSBoxTextArea_Description}
                            title='Description'
                            required={false}
                            style={{ width: "100%" }}
                        />
                    </NSRow>
                </NSColumn>
            </NWSVolumeLayout>
        );
    }
}